<template>
    <div class="input-control custom-combo-box">
        <simple-dropdown :click-dropdown-menu-to-hide="true" :dropdown-arrow="false" :theme="theme"
                         :alignment="dropdownMenuAlignment"
                         :mouse-enter-to-show="mouseEnterToShow"
                         :dropdown-menu-offset="dropdownMenuOffsetTop">
            <template v-slot:triggerButtonContent>
                <button class="trigger-button d-flex align-items-center">
                    <span class="selected-label">
                        <span v-if="selectedItem">
                        {{selectedItem.label}} {{selectedLabelSuffix}}
                        </span>
                    </span>
                    <i class="dropdown-arrow gf"></i>
                </button>
            </template>
            <template v-slot:dropdownMenu>
                <div class="dropdown-content">
                    <div class="header" v-if="dropdownMenuHeader">{{dropdownMenuHeader}}</div>
                    <ul>
                        <li v-for="(item,index) in options" :key="index">
                            <button @click="setInputValue(item.value, false, true)" class="option-button"
                                    :class="{active: item.value===value}">{{item.label}}
                                <span v-if="item.note" class="note">{{ item.note }}</span>
                            </button>
                        </li>
                    </ul>
                </div>
            </template>
        </simple-dropdown>
    </div>
</template>

<script>
    import InputControlBase from "@/InputControls/InputControlBase";
    import SimpleDropdown from "@/components/SimpleDropdown";

    export default {
        name: "CustomComboBox",
        components: {SimpleDropdown},
        mixins: [InputControlBase],
        props: {
            options: Array,
            blockSelect: {
                default: false
            },
            theme: {
                default: 'primary'
            },
            dropdownMenuAlignment: {
                default: undefined,
            },
            dropdownMenuOffsetTop: {
                default: undefined,
            },
            dropdownMenuHeader: {
                default: undefined,
            },
            mouseEnterToShow: {
                default: undefined,
            },
            selectedLabelSuffix: {
                default: '',
            }
        },
        mounted() {
            if (!this.setInputValue(this.value, true)) {
                this.setInputValue(this.options[0].value, true);
            }
        },
        methods: {
            setInputValue(value, initial, userSelect) {
                if (!initial && this.blockSelect) {
                    if (userSelect) {
                        this.$emit('userSelectOption', value);
                    }
                    return false;
                }

                for (let i = 0; i < this.options.length; i++) {
                    if (this.options[i].value === value) {
                        this.value = value;
                        this.selectedItem = this.options[i];

                        if (userSelect) {
                            this.$emit('userSelectOption', value);
                        }
                        return true
                    }
                }
                return false;
            },
            focus() {

            }
        },
        data() {
            return {
                selectedItem: null,
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "input-controls";

    .dropdown-arrow {
        font-size: 13px;
        position: relative;
        /*top: 1px;*/
        transform: scale(0.8);

        &:after {
            content: '\e91c';
        }
    }

    .simple-dropdown.active {
        .dropdown-arrow {
            top: 0;

            &:after {
                content: '\e91b';
            }
        }
    }

    .trigger-button {
        background-color: transparent;
        border: none;
        color: inherit;
        padding: 3px 0;
        font-weight: normal;

        &:focus {
            box-shadow: none;
        }

        .selected-label {
            margin-right: 0.32rem;
            max-width: 180px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-weight: 600;
        }

        &:hover {
            color: inherit;
        }
    }

    .dropdown-content {
        .header {
            padding: 0 0.9rem;
            margin-bottom: 0.25rem;
            font-size: 0.86em;
            opacity: 0.6;
        }

        .option-button {
            .note {
                opacity: 0.6;
            }

            &.active {
                position: relative;

                &:before {
                    content: '';
                    display: block;
                    position: absolute;
                    top: calc(50% - 3px);
                    left: 6px;
                    width: 6px;
                    height: 6px;
                    border-radius: 50%;
                }
            }
        }
    }
</style>
<style lang="scss">
    @import "../assets/variables";

    .simple-dropdown[data-theme="primary"] {
        &.active {
            .trigger-button {
                color: orange;
            }
        }
    }

    .simple-dd-menu[data-theme="primary"] {
        color: white;
        .dropdown-wrapper {
            background-color: $primary-purple;
        }

        .dropdown-content {

            .option-button {
                color: white;

                &:hover {
                    background-color: rgba(white, 0.1);
                }

                &.active {
                    &:before {
                        background-color: orange;
                    }
                }
            }
        }
    }

    .simple-dropdown[data-theme="light"] {
        &.active {
            .trigger-button {
                opacity: 0.8;
            }
        }
    }

    .simple-dd-menu[data-theme="light"] {

        .dropdown-content {

            .option-button {

                &:hover {
                    background-color: rgba(black, 0.1);
                }

                &.active {
                    &:before {
                        background-color: orange;
                    }
                }
            }
        }
    }
</style>
